export const IMRA_TEACHER_BUNDLE_HREF =
  "/content/subject/cmlil97by00083b6t5nz1z9ic";
export const IMRA_STUDENT_BUNDLE_HREF =
  "/content/subject/cmm2plr1200083b6t1cljvns7";

export const IMRA_TEACHER_BUNDLE_TITLE = "Newsela ELA for Texas, Grades 2-5";
export const IMRA_STUDENT_BUNDLE_TITLE =
  "Newsela ELA for Texas 2-5 (Student Edition)";
